<template>
  <div class="global-side-menu" :class="{ open: isOpen }">
    <transition name="overlay">
      <div v-if="isOpen" class="overlay" @click="close"></div>
    </transition>
    <transition name="drawer">
      <aside v-if="isOpen" class="drawer" role="dialog" aria-modal="true" :aria-label="$t('globalSideMenu.ariaOpen')">
        <nav class="drawer-body">
          <!-- Section A -->
          <section class="menu-section">
            <router-link
              class="menu-item"
              :class="{ active: isActiveRoute('home') }"
              :to="{ name: 'home' }"
              @click.native="close"
            >
              <img class="menu-icon" :src="icons.home" alt="" />
              <span class="menu-label">{{ $t("globalSideMenu.home") }}</span>
            </router-link>
            <button v-if="!isSpScreen" type="button" class="menu-item menu-item-button" @click="onClickNolaNovel">
              <img class="menu-icon" :src="icons.nolaNovel" alt="" />
              <span class="menu-label">{{ $t("globalSideMenu.nolaNovel") }}</span>
            </button>
            <router-link
              v-if="!isSpScreen && isFreePlan"
              class="menu-item"
              :class="{ active: isActiveRoute('subscriptionAnnounce') }"
              :to="{ name: 'subscriptionAnnounce' }"
              @click.native="close"
            >
              <img class="menu-icon premium-icon" :src="icons.premium" alt="" />
              <span class="menu-label">{{ $t("globalSideMenu.premium") }}</span>
            </router-link>
          </section>

          <hr class="divider" />

          <!-- Section B -->
          <section class="menu-section">
            <router-link
              class="menu-item"
              :class="{ active: isActiveRoute('novelCreate') }"
              :to="{ name: 'novelCreate' }"
              @click.native="close"
            >
              <img class="menu-icon" :src="icons.novelCreate" alt="" />
              <span class="menu-label">{{ $t("globalSideMenu.novelCreate") }}</span>
            </router-link>
            <router-link
              v-if="!isSpScreen"
              class="menu-item"
              :class="{ active: isActiveRoute('nolaNovel') }"
              :to="{ name: 'nolaNovel' }"
              @click.native="close"
            >
              <img class="menu-icon" :src="icons.submit" alt="" />
              <span class="menu-label">{{ $t("globalSideMenu.submit") }}</span>
            </router-link>
            <router-link
              v-if="!isSpScreen"
              class="menu-item"
              :class="{ active: isActiveRoute('memo') }"
              :to="{ name: 'memo' }"
              @click.native="close"
            >
              <img class="menu-icon" :src="icons.creativeMemo" alt="" />
              <span class="menu-label">{{ $t("globalSideMenu.creativeMemo") }}</span>
            </router-link>
            <router-link
              v-if="!isSpScreen"
              class="menu-item"
              :class="{ active: isActiveRoute('agent') }"
              :to="{ name: 'agent' }"
              @click.native="close"
            >
              <img class="menu-icon" :src="icons.agent" alt="" />
              <span class="menu-label">{{ $t("globalSideMenu.agent") }}</span>
            </router-link>
            <router-link
              v-if="!isSpScreen"
              class="menu-item"
              :class="{ active: isActiveRoute('eventContest') }"
              :to="{ name: 'eventContest' }"
              @click.native="close"
            >
              <img class="menu-icon" :src="icons.contest" alt="" />
              <span class="menu-label">{{ $t("globalSideMenu.contest") }}</span>
            </router-link>
            <router-link
              v-if="!isSpScreen"
              class="menu-item"
              :class="{ active: isActiveRoute('eventCompany') }"
              :to="{ name: 'eventCompany' }"
              @click.native="close"
            >
              <img class="menu-icon" :src="icons.editorBoard" alt="" />
              <span class="menu-label">{{ $t("globalSideMenu.editorBoard") }}</span>
            </router-link>
            <router-link
              class="menu-item"
              :class="{ active: isActiveRoute('knowhow') }"
              :to="{ name: 'knowhow' }"
              @click.native="close"
            >
              <img class="menu-icon" :src="icons.learning" alt="" />
              <span class="menu-label">{{ $t("globalSideMenu.learning") }}</span>
            </router-link>
            <router-link
              class="menu-item"
              :class="{ active: isActiveRoute('assistantCatHome') }"
              :to="{ name: 'assistantCatHome' }"
              @click.native="onClickAssistantCat"
            >
              <img class="menu-icon" :src="icons.assistantCat" alt="" />
              <span class="menu-label">{{ $t("globalSideMenu.assistantCat") }}</span>
            </router-link>
          </section>

          <hr class="divider" />

          <!-- Section C -->
          <section class="menu-section">
            <a
              v-if="!isSpScreen && !isFreePlan"
              class="menu-item"
              :href="desktopAppUrl"
              target="_blank"
              rel="noopener noreferrer"
              @click="onClickDesktopApp"
            >
              <img class="menu-icon" :src="icons.desktopApp" alt="" />
              <span class="menu-label menu-label-with-new">
                {{ $t("globalSideMenu.desktopApp") }}
                <span class="menu-new">new</span>
              </span>
            </a>
            <router-link
              class="menu-item"
              :class="{ active: isActiveRoute('news') }"
              :to="{ name: 'news' }"
              @click.native="close"
            >
              <img class="menu-icon" :src="icons.news" alt="" />
              <span class="menu-label">{{ $t("globalSideMenu.news") }}</span>
            </router-link>
            <router-link
              class="menu-item"
              :class="{ active: isActiveRoute('inbox') }"
              to="/inbox"
              @click.native="close"
            >
              <img class="menu-icon" :src="icons.inbox" alt="" />
              <span class="menu-label">{{ $t("globalSideMenu.inbox") }}</span>
            </router-link>
            <router-link
              class="menu-item"
              :class="{ active: isActiveRoute('myPage') }"
              :to="{ name: 'myPage' }"
              @click.native="close"
            >
              <img class="menu-icon" :src="icons.myPage" alt="" />
              <span class="menu-label">{{ $t("globalSideMenu.myPage") }}</span>
            </router-link>
          </section>

          <hr class="divider" />

          <!-- Section D -->
          <section class="menu-section">
            <button type="button" class="menu-item menu-item-button" @click="onClickLogout">
              <span class="menu-label">{{ $t("globalSideMenu.logout") }}</span>
            </button>
            <a class="menu-item" :href="helpUrl" target="_blank" rel="noopener noreferrer" @click="close">
              <span class="menu-label">{{ $t("globalSideMenu.help") }}</span>
            </a>
          </section>

          <!-- Section E -->
          <section class="menu-section small-links">
            <div class="small-links-row">
              <router-link class="small-link" :to="{ name: 'terms' }" target="_blank" @click.native="close">
                {{ $t("common.termsOfService") }}
              </router-link>
              <router-link class="small-link" :to="{ name: 'privacy' }" target="_blank" @click.native="close">
                {{ $t("common.privacyPolicy") }}
              </router-link>
            </div>
            <div class="small-links-row">
              <router-link
                class="small-link"
                :to="{ name: 'specifiedCommercialTransactionsAct' }"
                target="_blank"
                @click.native="close"
              >
                {{ $t("common.specifiedCommercialTransactionsAct") }}
              </router-link>
              <router-link
                class="small-link"
                :to="{ name: 'paymentServicesAct' }"
                target="_blank"
                @click.native="close"
              >
                {{ $t("common.paymentServicesAct") }}
              </router-link>
            </div>
            <div class="small-links-row">
              <router-link class="small-link" :to="{ name: 'contact' }" @click.native="close">
                {{ $t("common.contact") }}
              </router-link>
              <a class="small-link" href="https://indent.co.jp/" target="_blank" rel="noopener noreferrer" @click="close">
                {{ $t("common.companyInfo") }}
              </a>
            </div>
          </section>
        </nav>
      </aside>
    </transition>
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import { NolaNovelUrlGenerator } from "@/lib/utils/generator/nolanovelUrl";
import { createUrlWithUtmParams } from "@/lib/utils/url";
import { NolaAnalytics, NolaItemId, NolaPageName } from "@/lib/utils/analytics";
import spScreenMixin from "@/mixins/spScreenMixin";

// アイコン
import HomeIcon from "@/assets/icons/figma/Home.svg";
import BookOpenIcon from "@/assets/icons/figma/BookOpen.svg";
import PremiumIcon from "@/assets/icons/figma/Premium.svg";
import BookPlusIcon from "@/assets/icons/figma/BookPlus.svg";
import PaperPlaneIcon from "@/assets/icons/figma/PaperPlane.svg";
import NoteBookIcon from "@/assets/icons/figma/NoteBook.svg";
import TrophyIcon from "@/assets/icons/figma/Trophy.svg";
import PawIcon from "@/assets/icons/figma/Paw.svg";
import PenToolIcon from "@/assets/icons/figma/PenTool.svg";
import GraduationCapIcon from "@/assets/icons/figma/GraduationCap.svg";
import MegaphoneIcon from "@/assets/icons/figma/Megaphone.svg";
import BetaIcon from "@/assets/icons/figma/Beta.svg";
import InboxIcon from "@/assets/icons/figma/Inbox.svg";
import UserIcon from "@/assets/icons/figma/User.svg";
import AssistantHomeIcon from "@/assets/icons/figma/AssistantHome.svg";

const DESKTOP_APP_OPEN_BETA_URL = "https://booming-buckthorn-e8b.notion.site/nola-desktop-openbe-ta";

interface Data {}

interface Computed {
  icons: Record<string, string>;
  helpUrl: string;
  desktopAppUrl: string;
  isFreePlan: boolean;
  isActiveRoute: (name: string) => boolean;
}

interface Methods {
  close(): void;
  onClickDesktopApp(): void;
  onClickLogout(): Promise<void>;
  onClickNolaNovel(): Promise<void>;
  onClickAssistantCat(): void;
  onKeydown(event: KeyboardEvent): void;
  lockBodyScroll(): void;
  unlockBodyScroll(): void;
}

interface Props {
  isOpen: boolean;
}

export default Vue.extend<Data, Methods, Computed, Props>({
  mixins: [spScreenMixin],
  props: {
    isOpen: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    icons() {
      return {
        home: HomeIcon,
        nolaNovel: BookOpenIcon,
        premium: PremiumIcon,
        novelCreate: BookPlusIcon,
        submit: PaperPlaneIcon,
        creativeMemo: NoteBookIcon,
        contest: TrophyIcon,
        agent: PawIcon,
        editorBoard: PenToolIcon,
        learning: GraduationCapIcon,
        desktopApp: BetaIcon,
        news: MegaphoneIcon,
        inbox: InboxIcon,
        myPage: UserIcon,
        assistantCat: AssistantHomeIcon,
      };
    },
    helpUrl() {
      return process.env.VUE_APP_NOTION_HELP || "";
    },
    desktopAppUrl() {
      return DESKTOP_APP_OPEN_BETA_URL;
    },
    isFreePlan() {
      return this.$store.getters["billingModule/isFreePlan"];
    },
    isActiveRoute() {
      return (name: string) => this.$route.name === name;
    },
  },
  watch: {
    isOpen(open: boolean) {
      if (open) {
        this.lockBodyScroll();
        document.addEventListener("keydown", this.onKeydown);
      } else {
        this.unlockBodyScroll();
        document.removeEventListener("keydown", this.onKeydown);
      }
    },
  },
  mounted() {
    // 親 (#header) が `position: sticky; z-index: 20` でスタッキングコンテキストを
    // 作るため、ドロワーをそのまま描画すると ButtonRound (z-index 80) などより
    // 下に隠れてしまう。body 直下に移して独立したスタッキングコンテキストにする。
    if (this.$el instanceof HTMLElement) {
      document.body.appendChild(this.$el);
    }
  },
  beforeDestroy() {
    this.unlockBodyScroll();
    document.removeEventListener("keydown", this.onKeydown);
    if (this.$el instanceof HTMLElement && this.$el.parentNode === document.body) {
      document.body.removeChild(this.$el);
    }
  },
  methods: {
    close() {
      this.$emit("close");
    },
    onClickDesktopApp() {
      new NolaAnalytics(this.$gtm, this.$store).logButtonEvent(NolaItemId.SideMenuDesktopAppOpenBetaClick);
      this.close();
    },
    async onClickLogout() {
      const { logout } = await import("@/lib/utils/auth");
      this.close();
      await logout();
    },
    async onClickNolaNovel() {
      const baseUrl = process.env.VUE_APP_NOLANOVEL_WEB;
      if (!baseUrl) {
        throw new Error("NolaノベルのWebサイトURLが環境変数に含まれていません。");
      }
      const service = new NolaNovelUrlGenerator(baseUrl);
      const aboutUrl = await service.genAboutUrl();
      window.open(
        createUrlWithUtmParams(aboutUrl, NolaPageName.Detail, NolaItemId.UseNolaNovelButton),
        process.env.VUE_APP_NOLANOVEL_NAME
      );
      this.close();
    },
    onClickAssistantCat() {
      const nolaAnalytics = new NolaAnalytics(this.$gtm, this.$store);
      nolaAnalytics.logButtonEvent(NolaItemId.AssistantCatHomeDrawerButton);
      this.close();
    },
    onKeydown(event: KeyboardEvent) {
      if (event.key === "Escape") {
        this.close();
      }
    },
    lockBodyScroll() {
      document.body.style.overflow = "hidden";
    },
    unlockBodyScroll() {
      document.body.style.overflow = "";
    },
  },
});
</script>

<style lang="scss" scoped>
@import "@/style-common.scss";

.global-side-menu {
  position: fixed;
  inset: 0;
  pointer-events: none;
  z-index: 200;

  &.open {
    pointer-events: auto;
  }
}

.overlay {
  position: absolute;
  inset: 0;
  background-color: var(--color-overlay);
}

.drawer {
  position: absolute;
  top: 0;
  left: 0;
  width: 280px;
  height: 100vh;
  background-color: var(--color-background-normal);
  box-shadow: var(--shadow-md);
  display: flex;
  flex-direction: column;
  overflow-y: auto;
}

.drawer-body {
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: 16px 0 24px;
}

.menu-section {
  display: flex;
  flex-direction: column;
  padding: 8px 0;
}

.divider {
  border: none;
  border-top: 1px solid var(--color-border);
  margin: 0 24px;
}

.menu-item {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 12px 24px;
  color: var(--color-text-normal);
  text-decoration: none;
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-regular);
  background: transparent;
  border: none;
  cursor: pointer;
  text-align: left;
  position: relative;
  @include hover-overlay;

  &.active {
    font-weight: var(--font-weight-bold);
    background-color: var(--color-surface-hover);
  }
}

.menu-item-button {
  width: 100%;
  font-family: inherit;
}

.menu-icon {
  width: 24px;
  height: 24px;
  flex-shrink: 0;
  filter: brightness(0);

  [data-app-theme="dark"] & {
    filter: brightness(0) invert(1);
  }

  &.premium-icon {
    filter: none;

    [data-app-theme="dark"] & {
      filter: none;
    }
  }
}

.menu-label {
  flex: 1;
  line-height: var(--line-height-default);
}

.menu-label-with-new {
  display: flex;
  align-items: center;
  gap: 6px;
}

.menu-new {
  color: var(--color-danger);
  font-size: var(--font-size-xxs);
  font-weight: var(--font-weight-bold);
  line-height: 1;
  transform: translateY(-1px);
}

.small-links {
  padding: 12px 24px;
  gap: 6px;
}

.small-links-row {
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
}

.small-link {
  font-size: var(--font-size-xs);
  color: var(--color-text-low);
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
}

// transitions
.overlay-enter-active,
.overlay-leave-active {
  transition: opacity 200ms ease;
}
.overlay-enter,
.overlay-leave-to {
  opacity: 0;
}

.drawer-enter-active,
.drawer-leave-active {
  transition: transform 200ms ease;
}
.drawer-enter,
.drawer-leave-to {
  transform: translateX(-100%);
}
</style>
